import { Text, Box } from "@chakra-ui/react";
// import { AiFillHeart } from "react-icons/ai";
import "./App.css";
import Background from "./Components/Background";
import Navbar from "./Components/Navbar/Navbar";
import About from "./Pages/About/About";
import Contacts from "./Pages/Contacts";
import Home from "./Pages/Home/Home";
import Projects from "./Pages/Projects/Projects";
import Skills from "./Pages/Skills/Skills";
import Statistics from "./Pages/Statistics";
import ScrollButton from "./Components/AutoScrollUp";
// import SideBarIcons from "./Components/sideIcons/SideIcons.jsx";
// import useReady from "./Components/useReady";
// import Loader from "./Pages/Loader";

function App() {
  // const {ready} = useReady(5000);
  // const intervalRef = useRef(null);
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   intervalRef.current = setInterval(() => {
  //     setLoading(false);
  //     clearInterval(intervalRef.current);
  //   }, 5000);
  //   return () => clearInterval(intervalRef.current);
  // }, []);
  return (
    // loading ? (
    //   <Loader />
    // ) :
  //   <Box>
  // {
  //   ready!==true?<Loader/>:
    <Box className="App" bgColor={"#040724"}>
      <Background />
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Statistics />
      <Contacts />
      <Box bg="#040724" fontSize={["22px", "16px", "15px"]}>
        <Text
          color={"orange"}
          fontSize={["17px", "14px", "16px"]}
          fontFamily={"Lora"}
          textAlign={"center"}
        >
          By Ayushi Vashisth
        </Text>
      </Box>
      <ScrollButton />
    </Box>
  // }
  // </Box>
  );
}

export default App;
